import { FC } from 'react'
import { Link } from 'react-router-dom'
import { useArpMedia } from '../../../__legacy__/queries/arpMedia'
import { useUser } from '../../../__legacy__/queries/users'
import { detailPagePath } from '../../arp-media-utils'
import { profilePath } from '../../profile'
import { Notification } from '../primatives'
import { ArpFavoritedNotificationType } from '../types'
import { notificationTimeAgo } from '../utils'

interface Props {
  notification: ArpFavoritedNotificationType
}

export const ActivityFavoritedNotification: FC<Props> = ({ notification }) => {
  const favoritedByQuery = useUser({
    walletAddressOrId: notification.data.triggeredByWalletAddress
  })
  const arpMediaQuery = useArpMedia({ id: notification.data.arpId })

  if (favoritedByQuery.isLoading || arpMediaQuery.isLoading) {
    return null
  }

  return (
    <Notification.Root>
      <Notification.Avatar src={favoritedByQuery.data.profilePicture?.url} />
      <Notification.Title>
        <Link to={profilePath(favoritedByQuery.data)}>
          <Notification.Link>{favoritedByQuery.data.displayName}</Notification.Link>
        </Link>
        {`favorited`}
        <Link to={detailPagePath(arpMediaQuery.data)}>
          <Notification.Link css={{ marginLeft: '4px' }}>
            {arpMediaQuery.data.metadata.title}
          </Notification.Link>
        </Link>
      </Notification.Title>
      <Notification.Stats>{notificationTimeAgo(notification.createdAt)}</Notification.Stats>
    </Notification.Root>
  )
}
